import { buildModelManager } from "../builder.js";
const DefaultSimulationSessionSelection = {
  __typename: true,
  id: true,
  accessedFromIPs: true,
  actionHistory: true,
  audioProcessingStatus: true,
  cohortId: true,
  completedAt: true,
  conversationId: true,
  conversationTranscript: true,
  createdAt: true,
  criticalErrors: true,
  currentState: true,
  debriefAudioMetadata: true,
  debriefAudioRecording: { url: true, mimeType: true, fileName: true },
  debriefAudioTranscription: { markdown: true, truncatedHTML: true },
  debriefTalkingPoints: { markdown: true, truncatedHTML: true },
  deviceBoundAt: true,
  deviceFingerprint: true,
  elapsedTimeMinutes: true,
  evaluationForm: true,
  evaluationNotes: { markdown: true, truncatedHTML: true },
  finalOutcome: true,
  handoffCompleted: true,
  handoffQuality: true,
  instructorId: true,
  instructorNotes: { markdown: true, truncatedHTML: true },
  isVoiceSession: true,
  learnerNotes: { markdown: true, truncatedHTML: true },
  realTimeMinutes: true,
  realtimeMetadata: true,
  runId: true,
  scenarioAudioMetadata: true,
  scenarioAudioRecording: { url: true, mimeType: true, fileName: true },
  scenarioAudioTranscription: { markdown: true, truncatedHTML: true },
  scenarioId: true,
  scenarioRunId: true,
  scenarioShareTokenId: true,
  scoreBreakdown: true,
  sessionId: true,
  sessionType: true,
  simulatorResponses: true,
  startedAt: true,
  status: true,
  totalScore: true,
  updatedAt: true,
  userId: true,
  voiceSimSessionId: true
};
const modelApiIdentifier = "simulationSession";
const pluralModelApiIdentifier = "simulationSessions";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findBySessionId",
    findByField: "sessionId",
    findByVariableName: "sessionId",
    modelApiIdentifier,
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindBySessionId",
    findByField: "sessionId",
    findByVariableName: "sessionId",
    modelApiIdentifier,
    defaultSelection: DefaultSimulationSessionSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createSimulationSession",
    operationReturnType: "CreateSimulationSession",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      simulationSession: { required: false, type: "CreateSimulationSessionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSimulationSessionSelection
  },
  {
    type: "action",
    operationName: "bulkCreateSimulationSessions",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateSimulationSessionsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSimulationSessionSelection
  },
  {
    type: "action",
    operationName: "updateSimulationSession",
    operationReturnType: "UpdateSimulationSession",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      simulationSession: { required: false, type: "UpdateSimulationSessionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSimulationSessionSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateSimulationSessions",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateSimulationSessionsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSimulationSessionSelection
  },
  {
    type: "action",
    operationName: "deleteSimulationSession",
    operationReturnType: "DeleteSimulationSession",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteSimulationSessions",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertSimulationSession",
    operationReturnType: "UpsertSimulationSession",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      simulationSession: { required: false, type: "UpsertSimulationSessionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateSimulationSessionResult": { hasReturnType: false },
      "... on UpdateSimulationSessionResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSimulationSessionSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertSimulationSessions",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertSimulationSessionsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultSimulationSessionSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "simulationSessionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const SimulationSessionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSimulationSessionSelection,
  operations
);
export {
  DefaultSimulationSessionSelection,
  SimulationSessionManager
};
//# sourceMappingURL=SimulationSession.js.map
